import { API_URL } from '../../../config/env';
// src/user/services/api/index.js

/**
 * Centralized API client for user space
 * Handles common configuration, error handling, and request/response logic
 */

class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

/**
 * Internal JSON fetch helper that:
 * - sets JSON headers
 * - throws an ApiError with status and body on non-OK
 */
async function apiRequest(url, options = {}) {
  const {
    method = 'GET',
    body,
    headers = {},
    signal,
    ...restOptions
  } = options;

  const requestHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  const config = {
    method,
    headers: requestHeaders,
    signal,
    ...restOptions,
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  const response = await fetch(url, config);
  const text = await response.text();
  const responseBody = text ? safeJsonParse(text) : null;

  if (!response.ok) {
    throw new ApiError(
      `Request failed (${response.status}${response.statusText ? ` ${response.statusText}` : ''})`,
      response.status,
      responseBody
    );
  }

  return responseBody;
}

function safeJsonParse(text) {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

/**
 * Build URL with proper encoding
 */
function buildUrl(path, params = {}) {
  const url = new URL(path, API_URL);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
}

export { apiRequest, buildUrl };
